import { Component } from '@angular/core'

@Component({
  templateUrl: './lector-manual-en.component.html',
  styleUrls: ['../lector-manual.component.less'],
  selector: 'app-lector-manual-en',
})
export class LectorManualComponentEn {}
